export default __webpack_public_path__ + "static/media/fossil7.54f4ba6a.png";